import { createFileRoute } from '@tanstack/react-router';

import { RegisterRequests } from '@/pages/admin/register-requests/RegisterRequests';

export const Route = createFileRoute('/admin/_admin/register-requests')({
  component: RegisterRequests
});
